import { render, staticRenderFns } from "./ScheduleTabs.vue?vue&type=template&id=6fa22a74&scoped=true"
import script from "./ScheduleTabs.vue?vue&type=script&lang=js"
export * from "./ScheduleTabs.vue?vue&type=script&lang=js"
import style0 from "./ScheduleTabs.vue?vue&type=style&index=0&id=6fa22a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa22a74",
  null
  
)

export default component.exports